import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { LANGUAGES } from '../constants/localization.constants';

export const useInitLanguage = () => {
	const { i18n } = useTranslation();

	useEffect(() => {
		const language = getInitialLanguage();

		if (LANGUAGES.includes(language)) {
			i18n.changeLanguage(language);
		}
	}, []);

	function getInitialLanguage() {
		if (window.location.href.includes('ru')) {
			return 'ru';
		}

		if (window.location.href.includes('en')) {
			return 'en';
		}

		return 'ua';
	}
};
